<template>
  <div @submit="formSubmit">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "VacancyForm",
  methods: {
    formSubmit() {
      dataLayer.push({
        'event': 'application_sent'
      });
    }
  },
  mounted() {
    dataLayer.push({
      'event': 'application_view'
    });
  }
}
</script>